export default () => {
  const { username, roles } = useAuthorization()
  const i18n = useI18n()

  const translatedRole = computed(() => roles.value ? roles.value.map(role => i18n.t(`userRoles.${role}`) ?? 'Unbekannt').join(', ') : 'N/A')
  const formattedUsernameAndRole = computed(() => `${username.value} (${translatedRole.value})`)

  return { translatedRole, formattedUsernameAndRole }
}
